module.exports = __webpack_public_path__ + "prod/1.42.2/img/faq2.da83439c.png";